export const AUTH_REQUEST_PENDING = "AUTH_REQUEST_PENDING";
export const AUTH_REQUEST_SUCCESS = "AUTH_REQUEST_SUCCESS";
export const AUTH_REQUEST_FAILURE = "AUTH_REQUEST_FAILURE";

export const SIGNUP_REQUEST_PENDING = "SIGNUP_REQUEST_PENDING";
export const SIGNUP_REQUEST_SUCCESS = "SIGNUP_REQUEST_SUCCESS";
export const SIGNUP_REQUEST_FAILURE = "SIGNUP_REQUEST_FAILURE";
